import { Reducer } from 'redux';
import { LoadingIndicatorActions, LoadingIndicatorActionTypes, } from '../actions/loadingIndicator.action';

export interface ILoadingIndicatorState {
  readonly spinning: boolean;
  loadingCount: number;
}

// Define the initial state
const initialLoadingIndicatorState: ILoadingIndicatorState = {
  spinning: false,
  loadingCount: 0
};

export const loadingIndicatorReducer: Reducer<ILoadingIndicatorState, LoadingIndicatorActions> = (
  state = initialLoadingIndicatorState,
  action
) => {
  switch (action.type) {
    case LoadingIndicatorActionTypes.SHOW_LOADING: {
      state.loadingCount++
      return {
        ...state,
        spinning: true
      };
    }
    case LoadingIndicatorActionTypes.HIDE_LOADING: {
      let { loadingCount, spinning } = state
      if (loadingCount > 0) loadingCount--
      spinning = loadingCount !== 0
      return {
        ...state,
        spinning: spinning,
        loadingCount: loadingCount
      };
    }
    default:
      return state;
  }
};